import React from 'react';
import { SelectMenu } from 'components/SelectMenu';
import lockIcon from 'icons/lock.svg';
import useScreenWidthQuery from 'common/Hooks/UseScreenWidthQuery';
import { WindowBreakpoints } from 'utils/DocumentHelper';
import styles from './UncategorisedDropDown.module.scss';

const uncategorisedText = 'This category cannot be moved but all items can be dragged out.';
const UncategorisedDropDown: React.FC = () => {
  const [innerWidth] = useScreenWidthQuery();

  return (
    <SelectMenu
      openOnHover
      align={innerWidth < WindowBreakpoints.MD ? 'right' : 'center'}
      size="small"
      buttonStyle={styles.buttonStyle}
      downIcon={null}
      aria-describedby={uncategorisedText}
      defaultButtonContent={<img className={styles.lockIcon} src={lockIcon} alt="Lock Icon" />}
      options={[
        {
          content: <p className={styles.uncategorisedText}>{uncategorisedText}</p>,
          value: 'text',
          type: 'text'
        }
      ]}
    />
  );
};

export default UncategorisedDropDown;
